import { Component, OnInit } from '@angular/core';
import { OrganizationsService } from '../../organizations.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { CustomComponent } from 'src/app/core/view/component/custom/custom-component.interface';
import { ViewComponent } from 'src/app/core/view/view.component';
import { SageSalesService } from '../sage-sales-lines/sage-sales.service';
import { DialogService } from 'primeng/dynamicdialog';
import { SageSalesLinesComponent } from '../sage-sales-lines/sage-sales-lines.component';
import { ViewsService } from 'src/app/core/view/views.service';

@Component({
  selector: 'app-sage-sales-widget',
  templateUrl: './sage-sales-widget.component.html',
  styleUrls: ['./sage-sales-widget.component.scss']
})
export class SageSalesWidgetComponent implements OnInit, CustomComponent {
  public organization_id: string;
  public sales: any[] = [];
  public salesHeaders: Array<{ field: string; header: string }> = [];
  public loading: boolean = true;
  public currentPage: number = 0;
  public pageSize: number = 10;
  public hasNextPage: boolean = false;
  public totalRecords: number = 0;
  public first: number = 0;
  public rows: number = 10;


  constructor(
    private organizationService: OrganizationsService,
    private route: ActivatedRoute, private translateService: TranslateService,
    private sageSalesService: SageSalesService,
    private dialogService: DialogService, private viewService: ViewsService
  ) { }
  data: any;
  entity: any;
  view?: ViewComponent;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.organization_id = params['id'];
    });

    this.salesHeaders = [
      { field: 'FechaFactura', header: this.translateService.instant('sale.entity_fields.date') },
      { field: 'SerieFactura', header: this.translateService.instant('sale.entity_fields.description') },
      { field: 'NumeroFactura', header: this.translateService.instant('sale.entity_fields.number') },//invoice number
      { field: 'BaseImponible', header: this.translateService.instant('sale.entity_fields.base') },
      { field: 'TotalIva', header: this.translateService.instant('sale.entity_fields.vat') },
      { field: 'ImporteFactura', header: this.translateService.instant('sale.entity_fields.amount') },
    ];

    this.loadSales();
  }

  loadSales(event: any = null) {
    this.loading = true;
    if (event) {
      this.currentPage = event.first / event.rows;
      this.pageSize = event.rows;
    }
    var params = {
      page: this.currentPage,
      pageSize: this.pageSize
    };
    this.sageSalesService.getSalesByOrganization(this.organization_id, params).subscribe({
      next: (data: any) => {
        this.loading = false;
        this.sales = data.rows;
        this.totalRecords = data.totalRows;
      },
      error: (error: any) => {
        //TODO: messageService aquí.
        this.loading = false;
      }
    });
  }


  saleClicked(sale) {
    const ref = this.dialogService.open(SageSalesLinesComponent, {
      data: {
        organization_id: this.organization_id,
        sale: sale
      },
      header: this.translateService.instant('sagesale.lines_header'),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
    })
  }

  onEvent(event: string) {

  }
}
